import { render, staticRenderFns } from "./systemTagModal.vue?vue&type=template&id=422b704a&scoped=true&"
import script from "./systemTagModal.vue?vue&type=script&lang=js&"
export * from "./systemTagModal.vue?vue&type=script&lang=js&"
import style0 from "./systemTagModal.vue?vue&type=style&index=0&id=422b704a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422b704a",
  null
  
)

export default component.exports